<script setup lang="ts">
import SettingsInfo from "@/components/common/cards/SettingsInfo.vue";

defineProps<{
    title: string;
    description?: string;
}>();
</script>

<template>
    <section class="flex flex-col lg:flex-row gap-8 lg:gap-16 mb-16">
        <SettingsInfo :title="title" :description="description" />
        <slot />
    </section>
</template>
